module.exports = __webpack_public_path__ + "media/images/in-progress-b7f70076e33886cbbe968d81655fcd1e.svg";